<template>
  <div class="w1200">
    <h2>{{info.newsTitle}}</h2>
    <p class="time">发布日期：{{info.createTime}}</p>
    <div v-html="info.contents" class="newDetails"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      id:'',
      info:''
    }
  },
  mounted(){
    this.id = this.$route.params.id
    this.getInfo()
  },
  methods:{
    getInfo() {
      this.$api.getNewsDetail({id:this.id}).then(res=>{
        this.info = res.data
      })
    },
  }
}
</script>
<style>
  .newDetails img{
    max-width: 100%;
  }
</style>
<style scoped lang='stylus'>
  h2{
    text-align: center;
    font-size:32px;
    line-height: 60px;
  }
  .time{
    text-align: center;
    line-height: 40px;
    font-size: 16px;
    margin-bottom:50px;
  }
  .newDetails{
    font-size: 16px;
  }
</style>